import type { AdminRole } from '../types/api';

/**
 * Roles del sistema: constantes canónicas compartidas.
 *
 * Espejo del backend (`packages/backend/api/config/roles.ts`).
 * Mantener ambos archivos en sync — la lista canónica vive en backend,
 * el frontend la replica para selectores y filtros.
 */

/**
 * Roles cuyos usuarios pueden ser supervisados por un usuario con rol `supervisor`.
 */
export const SUPERVISABLE_ROLES: readonly AdminRole[] = ['telemarket', 'backseller'] as const;

/**
 * Roles que pueden recibir un colegio (destino de asignación).
 * Alineado al backend (`config/roles.ts`). Solo perfiles operativos.
 *
 * Nota: previamente esta lista incluía `admin`, pero el backend lo rechazaba en
 * runtime — bug preexistente que se corrige acá.
 */
export const ASSIGNABLE_ROLES: readonly AdminRole[] = ['backseller', 'telemarket'] as const;

/**
 * Devuelve `true` si el rol dado puede ser supervisado.
 */
export function isSupervisableRole(role: AdminRole): boolean {
  return (SUPERVISABLE_ROLES as readonly AdminRole[]).includes(role);
}

/**
 * Devuelve `true` si el rol dado puede recibir un colegio en asignación.
 */
export function isAssignableRole(role: AdminRole): boolean {
  return (ASSIGNABLE_ROLES as readonly AdminRole[]).includes(role);
}

/**
 * Label humano de cada rol — usar en tablas, dropdowns, badges.
 */
export const ROLE_LABELS: Record<AdminRole, string> = {
  root: 'Root',
  admin: 'Administrador',
  supervisor: 'Supervisor',
  backseller: 'Backseller',
  telemarket: 'Telemarketer',
  viewer: 'Consulta'
};
